// extracted by mini-css-extract-plugin
module.exports = {"songs":"Songs_songs__3KkM8","songs_list":"Songs_songs_list__-E3Zd","songs_list_item":"Songs_songs_list_item__3uEWs"};